export interface AudioTrackResource {
  stop: () => void;
}

export interface AudioStreamResource {
  getTracks: () => AudioTrackResource[];
}

export interface AudioContextResource {
  state: string;
  close: () => void | Promise<void>;
}

export interface InterviewResourceCleanupDependencies {
  clearStallTimer: () => void;
  isRecording: () => boolean;
  stopRecording: () => void;
  resetUi: () => void;
  stopSilenceDetection: () => void;
  getAudioStream: () => AudioStreamResource | null;
  clearAudioStream: () => void;
  getAudioContext: () => AudioContextResource | null;
  clearAudioContext: () => void;
  disconnectWebSocket: () => void;
  removeMobileReconnectHook: () => void;
  clearConnectionReferences: () => void;
}

/** 面接画面を離れる時の録音・音声・WebSocketリソース解放順序を管理する。 */
export class InterviewResourceCleanupController {
  private cleanedUp = false;

  constructor(private readonly dependencies: InterviewResourceCleanupDependencies) {}

  cleanup(): void {
    if (this.cleanedUp) return;
    this.cleanedUp = true;

    this.dependencies.clearStallTimer();
    if (this.dependencies.isRecording()) {
      this.dependencies.stopRecording();
    }

    this.dependencies.resetUi();
    this.dependencies.stopSilenceDetection();

    const audioStream = this.dependencies.getAudioStream();
    if (audioStream) {
      audioStream.getTracks().forEach((track) => track.stop());
      this.dependencies.clearAudioStream();
    }

    const audioContext = this.dependencies.getAudioContext();
    if (audioContext && audioContext.state !== 'closed') {
      void audioContext.close();
      this.dependencies.clearAudioContext();
    }

    this.dependencies.disconnectWebSocket();
    this.dependencies.removeMobileReconnectHook();
    this.dependencies.clearConnectionReferences();
  }
}
